import { NgModule } from '@angular/core';
import {
  NbAccordionModule,
  NbActionsModule,
  NbAlertModule,
  NbButtonModule,
  NbCalendarModule,
  NbCalendarRangeModule,
  NbCardModule,
  NbChatModule,
  NbCheckboxModule,
  NbDatepickerModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbProgressBarModule,
  NbRadioModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTimepickerModule,
  NbToggleModule,
  NbTreeGridModule,
  NbUserModule,
  NB_TIME_PICKER_CONFIG,
  NbStepperModule,
  NbPopoverModule
} from '@nebular/theme';

@NgModule({
  exports: [
    NbInputModule,
    NbCardModule,
    NbButtonModule,
    NbActionsModule,
    NbUserModule,
    NbCheckboxModule,
    NbRadioModule,
    NbDatepickerModule,
    NbSelectModule,
    NbIconModule,
    NbCheckboxModule,
    NbCardModule,
    NbLayoutModule,
    NbCalendarRangeModule,
    NbAlertModule,
    NbTabsetModule,
    NbListModule,
    NbTimepickerModule,
    NbAccordionModule,
    NbTreeGridModule,
    NbChatModule,
    NbStepperModule,
    NbProgressBarModule,
    NbSpinnerModule,
    NbToggleModule,
    NbPopoverModule,
    NbCalendarModule
  ],
  providers: [
    {
      provide: NB_TIME_PICKER_CONFIG,
      useValue: {}
    }
  ]
})
export class NebularModule {}
